export class FileUploadError {
    hasError: boolean = false;
    errorMessage: string = '';
}
